import {connect} from 'react-redux'
import * as actTableManagement from 'actions/tableManagement'
import ActionBar from './ActionBar'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import {browserHistory} from 'react-router'
import {formValueSelector} from 'redux-form'
import NoDataAndLoading from 'components/NoDataAndLoading'
import List from './List'
import ReportDetail from './ReportDetail'
import './TableManagementReport.css'

class TableManagementReport extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(actTableManagement.reportPageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {tableManagementReport, loadingSpinner} = this.props.data
    let {openRightColumn, reports} = tableManagementReport
    let {showLoadingSpinnerPage} = loadingSpinner
    return (
      <PageWrapper>
        <ActionBar onChangeOutlet={this._onChangeOutlet} onChangeDate={this._onChangeDate} onChangeStatus={this._onChangeStatus} onExport={this._onClickExport} />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={reports.length === 0}
              title='No data to display'
              description=''
            />
            {!showLoadingSpinnerPage && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <ReportDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
      </PageWrapper>
    )
  }

  _onChangeStatus = (statusIds) => {
    let {startDate, endDate} = this.props.search.date
    let {outletIds} = this.props.search
    this.props.dispatch(actTableManagement.changeReportStatus({
      outletIds,
      startDate: startDate,
      endDate: endDate,
      statusIds
    }))
  }

  _onChangeOutlet = (outletIds = []) => {
    let {startDate, endDate} = this.props.search.date
    let {statusIds} = this.props.search
    this.props.dispatch(actTableManagement.onReportsChangeOutletIds({
      outletIds,
      startDate,
      endDate,
      statusIds
    }))
  }

  _onChangeDate = ({startDate, endDate}) => {
    let {statusIds} = this.props.search
    let {outletIds} = this.props.search
    this.props.dispatch(actTableManagement.changeReportDate({
      outletIds,
      startDate: startDate,
      endDate: endDate,
      statusIds
    }))
  }

  _onClickExport = () => {
  }
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  return {
    search: {
      outletIds: selector(state, 'outletIds'),
      date: selector(state, 'date'),
      statusIds: selector(state, 'statusIds')
    },
    data: {
      tableManagementGroup: state.tableManagement.group,
      tableManagementReport: state.tableManagement.report,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    },
    nextAction: state.confirmAction.nextAction
  }
}

export default connect(mapStateToProps)(TableManagementReport)



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementReport/TableManagementReport.js